const FIRST_CELL_WIDTH = 150;
const SECOND_CELL_WIDTH = 350;

const LAST_CELL_WIDTH = 70;
const PRELAST_CELL_WIDTH = 240;

export const boxStyles = {
  '& div:nth-of-type(1)': {
    '& th, td': {
      '&:nth-of-type(1)': {
        width: `${FIRST_CELL_WIDTH + SECOND_CELL_WIDTH}px`,
      },

      '&:nth-last-of-type(1)': {
        width: `${LAST_CELL_WIDTH + PRELAST_CELL_WIDTH}px`,
      },
    },
  },

  '& div:nth-of-type(2)': {
    '& th, td': {
      border: '1px solid',
      borderColor: ({ palette }) => palette.border.default,

      '&:nth-of-type(1)': {
        width: `${FIRST_CELL_WIDTH}px`,
      },

      '&:nth-of-type(2)': {
        width: `${SECOND_CELL_WIDTH}px`,
      },

      '&:nth-last-of-type(1)': {
        width: `${LAST_CELL_WIDTH}px`,
      },

      '&:nth-last-of-type(2)': {
        width: `${PRELAST_CELL_WIDTH}px`,
      },
    },
  },
};
